import { Component } from '@angular/core';

@Component({
  selector: 'product-kpi',
  templateUrl: './product-kpi.component.html',
  styleUrls: ['./product-kpi.component.scss'],
})
export class ProductKpiComponent {
  readonly list = [
    {
      icon: '/assets/images/icons/Package.svg',
      title: 'Instant & Safe',
    },
    {
      icon: '/assets/images/icons/EnvelopeSimple.svg',
      title: 'Email Delivery',
    },
    {
      icon: '/assets/images/icons/SealCheck.svg',
      title: 'Warranty Support',
    },
  ];
}
